import gql from 'graphql-tag';
import { mutation } from 'services/graphql';
import { surfaceUnionFragment } from 'graphql/surface-node/fragments/surface-node-fragment/surface-node-union-fragment';

export const copySurfaceNodeByReferenceMutation = gql`
  mutation copySurfaceNodeByReference(
    $input: CopySurfaceNodeByReferenceInput!
  ) {
    copySurfaceNodeByReference(input: $input) {
      data {
        ...surfaceNodeUnionDetails
      }
      error
      success
    }
  }
  ${surfaceUnionFragment}
`;

export default mutation(copySurfaceNodeByReferenceMutation);
